import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './Image.sass';
import If from '../If';

// const getDimensionsFromImageFile = imageFileObj =>
//   new Promise((resolve, reject) => {
//     const fr = new FileReader();

//     fr.onload = function() {
//       // file is loaded
//       const img = new Image();

//       img.onload = function() {
//         resolve({ width: img.naturalWidth, height: img.naturalHeight });
//         // alert(img.width); // image is loaded; sizes are available
//       };

//       img.src = fr.result; // is the data URL because called with readAsDataURL
//     };

//     fr.readAsDataURL(imageFileObj); // I'm using a <input type="file"> for demonstrating
//   });

const noop = () => null;
class Image extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isImageLoaded: false,
    };
  }

  handleImageLoaded = () => {
    this.setState(() => ({
      isImageLoaded: true,
    }));
  };

  render() {
    const { isImageLoaded } = this.state;
    const {
      renderLoadingPlaceholder,
      height,
      width,
      imageUrl,
      objectFit,
      retinaImageUrl,
    } = this.props;
    const heightAndWidthStyle = {
      height,
      width,
    };
    return (
      <div
        style={{
          ...heightAndWidthStyle,
        }}
        className={styles.root}
      >
        <div
          className={styles.imageContainer}
          style={{
            height,
            width,
            display: isImageLoaded ? 'block' : 'none',
          }}
        >
          <img
            srcSet={
              retinaImageUrl ? `${imageUrl} 1x, ${retinaImageUrl} 2x` : ''
            }
            src={imageUrl}
            alt="grumpy cat"
            onLoad={() => {
              this.handleImageLoaded();
            }}
            style={{
              ...heightAndWidthStyle, // TODO: maybe just make this 100% width and height
              verticalAlign: 'top', // Why? https://stackoverflow.com/questions/5804256/image-inside-div-has-extra-space-below-the-image/5804278
              objectFit,
            }}
          />
        </div>
        <div
          className={styles.loadingPlaceholderContainer}
          style={{
            ...heightAndWidthStyle, // TODO: maybe just make this 100% width and height
            display: isImageLoaded ? 'none' : 'block',
          }}
        >
          {renderLoadingPlaceholder()}
        </div>
      </div>
    );
  }
}

Image.propTypes = {
  renderLoadingPlaceholder: PropTypes.func,
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  imageUrl: PropTypes.string.isRequired,
  retinaImageUrl: PropTypes.string,
  objectFit: PropTypes.oneOf([
    'fill',
    'contain',
    'cover',
    'none',
    'scale-down',
  ]),
};

Image.defaultProps = {
  retinaImageUrl: null,
  renderLoadingPlaceholder: noop,
  height: 'auto',
  width: '100%',
  objectFit: 'fill',
};

export { Image as default, Image };
